import { render, staticRenderFns } from "./EventManageDetails.vue?vue&type=template&id=48493699"
import script from "./EventManageDetails.vue?vue&type=script&lang=js"
export * from "./EventManageDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports